// Externals
import classNames from 'classnames';

// Shared helpers
import { getInitials } from 'helpers';

// Material helpers
import { Avatar, Typography, withStyles } from '@material-ui/core';
import { Padding } from '@mui/icons-material';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '8px 0'
    }
  },
  avatar: {
    marginRight: theme.spacing(1.5),
    width: 40,
    height: 40
  },
  title: {
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem'
    }
  },
  subtitle: {
    fontWeight: 400,
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  title_refresh: {
    marginLeft: '70px',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      marginLeft: '0px'
    }
  }
});

const PortletLabelAvatar = (props) => {
  const { classes, className, avatar, name, title, subtitle, ...rest } = props;

  const rootClassName = classNames(classes.root, className);

  return (
    <div {...rest} className={rootClassName}>
      <Avatar src={avatar} alt={name} className={classes.avatar}>
        <Typography variant="h5" style={{ color: 'white' }}>
          {getInitials(name || '')}
        </Typography>
      </Avatar>
      {title && (
        <Typography className={classes.title} variant="h5">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography className={classes.subtitle} variant="subtitle2">
          {subtitle}
        </Typography>
      )}
      <Typography
        className={classes.title_refresh}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1
        }}
        variant="h5">
        Refresh the page to see the real-time booking status
      </Typography>
    </div>
  );
};

export default withStyles(styles)(PortletLabelAvatar);
